import React from "react";
import { connect } from "react-redux";
import {
  changeSubMenu,
  editarPlanMovilidad,
  calcularMedidasSubmedidasTareasPlanMovilidad,
  handlerEstadoProcesoPlanMovilidad,
  onAlertaPlanMovilidad } from "../actions";
import KitDiagnosticoPlanMovilidad from "./kit";
import { scrollElementToTop, dataLayerTag } from "../functions";

class MainDiagnosticoPlanMovilidad extends React.PureComponent {

  componentDidMount = () => {
    scrollElementToTop("mainContent");
  }

  render() {
    return (
      <div id="diagnostico_plan_movilidad">
        <section id="content-etapa">
          <div className="container-fluid">
            <div className="row PM-plan-borde-spacing">
              <div className="col-md-12 text-center PM-tipo-denuncias-select">
                <div className="row col-md-12 text-center">
                  <div className="PM-section-title col-md-12 text-center">Para comenzar con el diagnóstico de tu centro de trabajo</div>
                  <div className="col-md-12 text-center"><h5>realiza las siguientes tareas:</h5></div>
                </div>
              </div>
              <div className="col-md-12 text-center PM-plan-contador-tareas PM-home-item-plan">
                <ul>
                  <li className="PM-border-line">
                    <div className="row">
                      <div className="col-sm-9 text-left">
                        <div className="PM-cuadro-3">
                          <h5><strong>Invita a los trabajadores a contestar la encuesta de diagnóstico de movilidad.</strong></h5>
                          <p>Crea un enlace para que los trabajadores puedan acceder a la encuesta virtual.</p>
                        </div>
                      </div>
                      <div className="col-sm-3 btn-material">
                        <button
                          className="btn PM-dx-button-plan PM-dx-button-plan-100 PM-button-light"
                          onClick={() => { this.props.dispatch(changeSubMenu(2)); }}
                          disabled={this.props.estadoProceso !== 2}
                        >Encuesta trabajadores</button>
                      </div>
                    </div>
                  </li>
                  <li className="PM-border-line">
                    <KitDiagnosticoPlanMovilidad />
                  </li>
                  <li>
                    <div className="row">
                      <div className="col-sm-9 text-left">
                        <div className="PM-cuadro-3">
                          <h5><strong>Contesta el formulario de Diagnóstico de Movilidad.</strong></h5>
                          <p>Imprime la versión digital disponible en el kit y recorre un perímetro de 5 cuadras alrededor del centro de trabajo, levantando la información solicitada. Luego, ingresa la información en el link.</p>
                        </div>
                      </div>
                      <div className="col-sm-3 btn-material">
                        <button
                          className="btn PM-dx-button-plan PM-dx-button-plan-100 PM-button-light"
                          onClick={() => { this.props.dispatch(changeSubMenu(1)); }}
                          disabled={ this.props.estadoProceso !== 2 || !this.props.esEncargado }
                        >Responder diagnóstico CT</button>
                      </div>
                    </div>
                  </li>
                  <li className="PM-border-line">
                    <div className="row">
                      <div className="col-sm-9 text-left">
                        <div className="PM-cuadro-3">
                          <h5><strong>Finaliza la etapa y podrás descargar el informe de diagnóstico y las medidas que proponemos.</strong></h5>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="PM-border-line">
                    <div className="row">
                      <div className="col-md-12 text-center PM-info">
                        <p><strong>Plazo recomendado:</strong> 2 semanas</p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="container-fluid PM-btn-box">
            <div className="text-center PM-plan-contador-finalizar">
              <button
                className="btn PM-dx-button-plan PM-dx-button-plan-100 PM-dx-button-plan-aire PM-button-cierre"
                onClick={() => {
                // verifico si está respondida la encuesta del centro y si la encuesta del trabajador finalizó
                  if (!this.props.estadoEncuestaCentro) {
                    this.props.dispatch(onAlertaPlanMovilidad("error", "Aún no se realiza el diagnóstico del centro de trabajo."));
                  } else if (this.props.cantidadHombresCentro < 0 && this.props.cantidadMujeresCentro < 0) {
                    this.props.dispatch(onAlertaPlanMovilidad("error", "Aún no define las cantidades de personas del centro."));
                  } else if (!this.props.fechaCierreEncuestaTrabajador) {
                    this.props.dispatch(onAlertaPlanMovilidad("error", "Aún no define la fecha de cierre de la encuesta."));
                  } else if (this.props.estadoTokenEncuesta) {
                    this.props.dispatch(onAlertaPlanMovilidad("error", "Debe finalizar la encuesta de trabajadores"));
                  } else {
                  // cambio la etapa del plan
                    this.props.dispatch(handlerEstadoProcesoPlanMovilidad(3));
                    // calculo las medidas
                    this.props.dispatch(calcularMedidasSubmedidasTareasPlanMovilidad(this.props.idplanMovilidad));
                    // envío la información
                    this.props.dispatch(editarPlanMovilidad(
                      this.props.idplanMovilidad,
                      this.props.estadoPlan,
                      this.props.estadoEjecucion,
                      3, // this.props.estadoProceso,
                      3, // paso a pestaña finalizar
                    ));
                    // gtd -> etapa 2 finalizada (diagnóstico)
                    dataLayerTag({
                      'event': 'etapa_2_finalizada',
                      'etapa': '2'
                    });
                    // gtd -> inicio de etapa 3 (Configuración)
                    dataLayerTag({
                      'event': 'etapa_3_llegada',
                      'etapa': '3'
                    });
                  }
                }}
                disabled = {this.props.estadoProceso !== 2 || !this.props.esEncargado}
              > Siguiente
              </button>
            </div>
          </div>
        </section>
        <div className="PM-footer">&nbsp;</div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  usuarioRUT: state.global.userData.RUT,
  usuarioNombre: state.global.userData.FirstName,
  usuarioApellido: state.global.userData.LastName,
  idplanMovilidad: state.planMovilidad.idplanMovilidad,
  estadoEjecucion: state.planMovilidad.estadoEjecucion,
  estadoPlan: state.planMovilidad.estadoPlan,
  estadoProceso: state.planMovilidad.estadoProceso,
  estadoEncuestaCentro: state.planMovilidad.estadoEncuestaCentro,
  cantidadHombresCentro: state.planMovilidad.cantidadHombresCentro,
  cantidadMujeresCentro: state.planMovilidad.cantidadMujeresCentro,
  fechaCierreEncuestaTrabajador: state.planMovilidad.fechaCierreEncuestaTrabajador,
  estadoTokenEncuesta: state.planMovilidad.estadoTokenEncuesta,
  listaContenidos: state.planMovilidad.listaContenidos,
  esEncargado: state.planMovilidad.esEncargado,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(MainDiagnosticoPlanMovilidad);
